<style>
  th,
  td {
    background-color: #eaeaea !important;
    padding: 13px !important;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    line-height: 1.72;
    text-transform: uppercase;
    color: #000;
    font-weight: 500;
    font-size: 14px;
    height: 30px !important;
  }

  .b-b {
    border-bottom: 1px solid #e0e0e0 !important;
  }

  .p-0 {
    padding: 0px !important;
  }

  .mat-elevation-z8 {
    box-shadow: none !important;

  }
</style>
<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<div mat-dialog-title>

</div>
<div mat-dialog-content>
  <form class="example-form">
    <div class="fx-col">
      <div class="fx-flex-100-in-col">
        <p class="m-t-20 ng-scope">{{"Please_enter_enroller" | translate: {Default: "Please enter the ID or name of the
          person that
          referred you company name."} }}</p>
          </div>
      <div class="searchInput fx-row fx-flex-100-in-col">
        <mat-form-field class="fx-flex">
          <input type="text" aria-label="Number" [(ngModel)]="searchText" matInput [formControl]="myControl">
          <button mat-button matSuffix (click)="searchEnroller(searchText)">
            <mat-icon matSuffix class="arrow-icon">arrow_right_alt</mat-icon>
            </button>
        </mat-form-field>
          </div>
        </div>
   </form>


  <div class="enroller-data-table">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <!-- Checkbox Column -->
      <ng-container matColumnDef="SelectEnroller">
        <th mat-header-cell *matHeaderCellDef>
          SelectEnroller
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? singleSelection($event, row) : null"
            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row) == true">
          </mat-checkbox>
        </td>
      </ng-container>
      <!-- NAME Column -->
      <ng-container matColumnDef="ProfileImageUrl">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
        <td mat-cell *matCellDef="let element" class="avtar">
          <img [src]="configService.localSettings.Disco.DiscoUrl+element.ProfileImageUrl"
            [default]="'assets/img/noimage.png'" />
        </td>
      </ng-container>
      <ng-container matColumnDef="FirstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> NAME </th>
        <td mat-cell *matCellDef="let element"> {{element.FirstName}} {{element.LastName}} </td>
      </ng-container>
      <ng-container matColumnDef="LastName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> LegalFirstName </th>
        <td mat-cell *matCellDef="let element"> {{element.LegalFirstName}} {{element.LegalLastName}} </td>
      </ng-container>
      <ng-container matColumnDef="BackOfficeId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> BackOfficeId </th>
        <td mat-cell *matCellDef="let element"> {{element.BackOfficeId}}</td>
      </ng-container>
      <ng-container matColumnDef="EMail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> EMail </th>
        <td mat-cell *matCellDef="let element"> {{element.EMail}} </td>
      </ng-container>
      <ng-container matColumnDef="Phone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Phone </th>
        <td mat-cell *matCellDef="let element"> {{element.Phone}} </td>
      </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="b-b p-0"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="b-b p-0"></tr>
    </table>
    <mat-paginator [length]="itemCount" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
<div mat-dailog-actions class="enroller-footer">
  <div flex class="col-lg-12 col-md-12 p-b-15 p-t-15 ds_mob fx-row">
    <div flex class="d-flex fx-flex-70">
      <p> {{"dont_have_a_referral" | translate:{Default:"Don't have a referral?"} }}
      </p>
      &nbsp;
      <a class="f-s-14 p-2" [mat-dialog-close]="true" > {{"click_here" | translate:{Default:"Click Here"} }}</a>
    </div>
    <div class="fx-flex-30">
      <button mat-raised-button color="primary" class="f-s-18 pull-right" type="button" (click)="setSponsor();">{{
        'set_as_my_enroller' | translate:{Default:"Set as my consultant"} }}</button>
    </div>
  </div>
</div>